<template>
  <section>
    <h1>Agregar Notificación</h1>
    <hr/><br/>

    <form @submit.prevent="submit">
      <div class="mb-3">
        <label for="name" class="form-label">Nombre de la Notificación:</label>
        <input type="text" name="name" v-model="form.name" class="form-control" />
        <div v-if="errors.name" class="error">{{ errors.name }}</div>
      </div>
      <div class="mb-3">
        <label for="description" class="form-label">Descripción:</label>
        <textarea
          name="description"
          v-model="form.description"
          class="form-control"
        ></textarea>
        <div v-if="errors.description" class="error">{{ errors.description }}</div>
      </div>
      <div class="mb-3">
        <label for="scheduled_time" class="form-label">Hora Programada:</label>
        <input type="time" name="scheduled_time" v-model="form.scheduled_time" class="form-control" />
        <div v-if="errors.scheduled_time" class="error">{{ errors.scheduled_time }}</div>
      </div>
      <button type="submit" class="btn btn-primary">Guardar</button>
      <router-link :to="{name: 'Notifications', params: {id: this.id}}" class="btn btn-secondary">Cancelar</router-link>
    </form>
  </section>
</template>

<script>
import { defineComponent } from 'vue';
import { mapActions } from 'vuex';

export default defineComponent({
  name: 'AddNotificationView',
  props: ['id'],
  data() {
    return {
      form: {
        name: '',
        description: '',
        scheduled_time: ''
      },
      errors: {}
    };
  },
  methods: {
    ...mapActions(['createNotification']),
    async submit() {
      try {
        let notification = {
          name: this.form.name,
          description: this.form.description,
          scheduled_time: this.form.scheduled_time+ ':00-0600',
          proceeding_id: this.id,
          user_id: this.$store.state.users.user.id

        };

        await this.createNotification(notification);
        this.$router.push({name: 'Notifications', params: {id: this.id}});
      } catch (error) {
        console.log(error);
      }
    }
  }
});
</script>